<template lang="pug">
  .step
    h1 本人に配偶者(妻・夫)は現在いますか、又は過去にいましたか？
    .message_area
      .msg 遺産をお持ちの方を「本人」と表しております
    .button_area
      button(@click="button_yes_click") はい
      button(@click="button_no_click") いいえ
    .family_message 下に相続関係図が表示されます
</template>

<script lang="js">
export default {
  mounted() {
    localStorage.removeItem('_isan_data');
    this.$emit('init');
  },
  methods: {
    button_yes_click() {
      this.$emit('append_family', { mode: 2 });
      this.$router.push('/step01_2');
    },
    button_no_click() {
      this.$router.push('/step01_3');
    },
  },
};
</script>

<style lang="sass" scoped>
@import "../../assets/sass/component/step_style"
.message_area
  padding: 0 20px
  .msg
    font-size: 12px
    position: relative
    padding-left: 14px
    color: $clear-red
    &:before
      content: "※"
      position: absolute
      left: 0
</style>